import DataTables from '../../components/dataTables.js';
import Content from '../../content.js';

namespace('IO.Views.NodeGroups', function (exports) {
  'use strict';

  var ImpactedClusterSettingsResources = Content.extend({
    dom: {
      DATATABLES: '.dataTables',
    },

    render: function () {
      var $table = window.$(this.dom.DATATABLES),
        dataTableOpts;

      dataTableOpts = {
        columns: window.cluster_settings_impact_columns,
        data: window.impacted_resources,
        el: $table,
        filter: true,
        fixed: false,
        searching: true,
        sorting: [[0, 'asc']],
        fnRowCallback: function (nRow, aData) {
          if (
            typeof aData[0] === 'string' &&
            aData[0].indexOf('Remove') !== -1
          ) {
            $(nRow).addClass('negative');
          }
          return nRow;
        },
      };

      this.dataTable = new DataTables(dataTableOpts);
      this.dataTable.start();
    },
  });

  exports.ImpactedClusterSettingsResources = ImpactedClusterSettingsResources;
});
